import styled from 'styled-components'
import { motion } from 'framer-motion'

import { Text } from '../textElements'

export const StyledQuestion = styled.div`
  margin-bottom: 3rem;

  ${Text} {
    font-size: 1.35rem;
  }
`

export const Leaf = styled(motion.img)`
  display: block;
  width: 100%;
  max-width: 50px;
  height: auto;

  margin: 0 auto 1rem;
  opacity: 0;
`
